import React from 'react';
import { Button, Input } from '@cokitchen/cokitchen-components';
import CurrencyInput from 'components/base/currency-input';

type EditCostSettingType = {
  value: string;
  handleOnChange: (val: string) => void;
  loading: boolean;
  name: string;
  editCostSetting: (e: any) => void;
};
const EditCostSetting = ({
  handleOnChange,
  value,
  name,
  loading,
  editCostSetting
}: EditCostSettingType) => {
  const nameText = name?.replaceAll('_', ' ')?.toUpperCase();

  const isFixed = name === 'gas_consumption' || name === 'labour_cost';
  return (
    <div className='p-5 shadow-[0px_6px_40px_0px_rgba(98,103,106,0.15)] w-full bg-white rounded-xl'>
      <div className='flex justify-between mb-6'>
        <h3 className='text-xl font-semibold'>Edit {nameText}</h3>
      </div>

      <form className='w-full flex flex-col gap-10' onSubmit={editCostSetting}>
        {isFixed ? (
          <CurrencyInput
            label={nameText}
            placeholder='7.5'
            value={value}
            onChange={(val) => handleOnChange(val)}
          />
        ) : (
          <div className='w-full relative mb-10'>
            <Input
              inputClass='h-[46px] !pl-[14px] !pr-[70px]'
              label={nameText}
              placeholder='7.5'
              value={value}
              onChange={(val) => handleOnChange(val.target.value)}
              type='number'
            />

            <span className='rounded-[6px] px-3 py-1.5 text-xs bg-[#F2F2F3] absolute top-[40px] right-[20px] z-[1]'>
              %
            </span>
          </div>
        )}

        <Button
          variant='block'
          color='primary'
          loading={loading}
          className='w-[100%] h-[43px]'
          disabled={loading}
          type='submit'>
          Update
        </Button>
      </form>
    </div>
  );
};

export default EditCostSetting;
